/* Test 1 / V1 — presentation bridge only.
   The native [data-nd-tier] radio remains the source of truth. */
(function () {
  'use strict';

  function moneyText(card, selector, value, hiddenWhenEmpty) {
    var element = card.querySelector(selector);
    if (!element) return;
    var hasValue = Boolean(value);
    element.textContent = value || '';
    if (hiddenWhenEmpty) element.hidden = !hasValue;
  }

  function syncCard(card, radio) {
    if (!card || !radio) return;
    var selected = radio.checked;
    card.classList.toggle('is-selected', selected);
    card.setAttribute('aria-checked', selected ? 'true' : 'false');
    card.setAttribute('aria-disabled', radio.disabled ? 'true' : 'false');
    card.tabIndex = radio.disabled ? -1 : 0;

    moneyText(card, '[data-nd-v1-price]', radio.getAttribute('data-nd-total-value'));
    moneyText(card, '[data-nd-v1-was]', radio.getAttribute('data-nd-was-value'), true);
    moneyText(card, '[data-nd-v1-save]', radio.getAttribute('data-nd-save-money'), true);
  }

  function sync(root) {
    if (!root) return;
    root.querySelectorAll('[data-nd-v1-tier-for]').forEach(function (card) {
      var nativeRadio = document.getElementById(card.getAttribute('data-nd-v1-tier-for'));
      syncCard(card, nativeRadio);
    });
  }

  function roots(scope) {
    (scope || document).querySelectorAll('[data-nd-product]').forEach(sync);
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('[data-nd-v1-tier-for]');
    if (!card || card.getAttribute('aria-disabled') === 'true') return;

    var root = card.closest('[data-nd-product]');
    var nativeRadio = document.getElementById(card.getAttribute('data-nd-v1-tier-for'));
    if (!root || !nativeRadio || nativeRadio.disabled) return;

    nativeRadio.checked = true;
    nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    sync(root);
  });

  document.addEventListener('keydown', function (event) {
    var card = event.target.closest && event.target.closest('[data-nd-v1-tier-for]');
    if (!card || (event.key !== ' ' && event.key !== 'Enter')) return;
    event.preventDefault();
    card.click();
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-nd-tier]')) return;
    var root = event.target.closest('[data-nd-product]');
    window.requestAnimationFrame(function () { sync(root); });
  });

  function start(scope) { roots(scope); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
}());
